import React from 'react';
import { Container, Title, Text, Button, Group, Stack, Paper } from '@mantine/core';
import { useNavigate } from 'react-router-dom';

export function UnauthorizedPage() {
  const navigate = useNavigate();

  return (
    <Container size="sm" py="xl" mt={60} sx={{ minHeight: 'calc(100vh - 60px)' }}>
      <Paper shadow="md" p="xl" radius="md">
        <Stack spacing="lg">
          <Title order={2}>Access Denied</Title>
          <Text>
            You don't have permission to access this page. This area requires additional
            privileges that have not been granted to your account.
          </Text>
          <Group position="apart">
            <Button variant="outline" onClick={() => navigate('/')}>
              Return to Dashboard
            </Button>
          </Group>
        </Stack>
      </Paper>
    </Container>
  );
} 